<capra-icon-button
  class="help-menu-trigger {{ theme }}"
  [class.analyst-studio]="isAnalystStudio$ | async"
  [size]="(isAnalystStudio$ | async) === true ? 'x-large' : 'medium'"
  icon="icon-question"
  [matMenuTriggerFor]="menu"
  data-test="mode-help-menu-button"
></capra-icon-button>

<mat-menu #menu="matMenu">
  <ul class="help-menu">
    <li class="header">Help & Support</li>
    <li *ngIf="!isCommunity" class="link">
      <a
        modeIntercom
        [attr.href]="helpDocs.links['https://mode.com/help/articles/contact-us/']"
        target="_blank"
        rel="noopener"
      >
        Chat with us
      </a>
    </li>
    <li class="link">
      <a [attr.href]="helpDocs.links['https://mode.com/help']" target="_blank" rel="noopener"> Documentation </a>
    </li>

    <ng-container *ngIf="(isAnalystStudio$ | async) === false">
      <hr class="divider" />

      <li class="header" data-test="get-started">Get Started</li>
      <li class="link">
        <a [attr.href]="helpDocs.links['https://mode.com/help/get-started']" target="_blank" rel="noopener">
          Learn the basics
        </a>
      </li>
      <li *ngIf="!isGuest" class="link">
        <a
          [attr.href]="helpDocs.links['https://mode.com/help/articles/getting-started-with-mode/#invite-collaborators']"
          target="_blank"
          rel="noopener"
        >
          Getting your team on board
        </a>
      </li>

      <hr class="divider" />

      <li class="header" data-test="resources">Resources</li>
      <li class="link">
        <a href="https://mode.com/resources/#learn-to-code-for-analysis" target="_blank" rel="noopener">
          SQL & Python tutorials
        </a>
      </li>
      <li *ngIf="!isGuest" class="link">
        <a href="https://mode.com/example-gallery/" target="_blank" rel="noopener"> Custom data viz </a>
      </li>
      <li *ngIf="!isGuest" class="link">
        <a
          [attr.href]="helpDocs.links['https://mode.com/help/articles/querying-data/#sql-keyboard-shortcuts']"
          target="_blank"
          rel="noopener"
        >
          Keyboard shortcuts
        </a>
      </li>
      <li class="link">
        <a href="https://mode.com/blog/" target="_blank" rel="noopener"> {{ appName }} Blog </a>
      </li>
      <li *ngIf="!isGuest" class="link">
        <a href="https://updates.mode.com/" target="_blank" rel="noopener"> Release notes </a>
      </li>
    </ng-container>
  </ul>
</mat-menu>
